// @ts-nocheck
/* eslint-disable */

import BlockAccordion from '@/components/blocks/miewtheme/BlockAccordion/BlockAccordion';
import BlockArchiveGrid from '@/components/blocks/miewtheme/BlockArchiveGrid/BlockArchiveGrid';

import BlockButton from '@/components/blocks/core/BlockButton/BlockButton';
import BlockCarousel from '@/components/blocks/miewtheme/BlockCarousel/BlockCarousel';
import BlockColumns from '@/components/blocks/core/BlockColumns/BlockColumns';
import BlockCover from '@/components/blocks/core/BlockCover/BlockCover';
import BlockGravityForm from '@/components/blocks/miewtheme/BlockGravityForm/BlockGravityForm';
import BlockGroup from '@/components/blocks/core/BlockGroup/BlockGroup';
import BlockHeading from '@/components/blocks/core/BlockHeading/BlockHeading';
import BlockIconBox from '@/components/blocks/miewtheme/BlockIconBox/BlockIconBox';
import BlockIconTitle from '@/components/blocks/miewtheme/BlockIconTitle/BlockIconTitle';
import BlockImage from '@/components/blocks/core/BlockImage/BlockImage';
import BlockList from '@/components/blocks/core/BlockList/BlockList';
import BlockModal from '@/components/blocks/miewtheme/BlockModal/BlockModal';
import BlockParagraph from '@/components/blocks/core/BlockParagraph/BlockParagraph';
import BlockQuote from '@/components/blocks/core/BlockQuote/BlockQuote';
import BlockReusable from '@/components/blocks/core/BlockReusable/BlockReusable';
import BlockSearchPage from '@/components/blocks/miewtheme/BlockSearchPage/BlockSearchPage';
import BlockSeparator from '@/components/blocks/core/BlockSeparator/BlockSeparator';
import BlockSpacer from '@/components/blocks/core/BlockSpacer/BlockSpacer';
import BlockTaxonomyGrid from '@/components/blocks/miewtheme/BlockTaxonomyGrid/BlockTaxonomyGrid';

import BlockVideo from '@/components/blocks/core/BlockVideo/BlockVideo';
import BlockVideoEmbed from '@/components/blocks/core/BlockVideoEmbed/BlockVideoEmbed';
import { BlocksProps } from '../_types/blocksStyle';
import BlockLogosGrid from '@/components/blocks/miewtheme/BlockLogosGrid';
import BlockMarquee from '@/components/blocks/miewtheme/BlockMarquee';
import BlockMarqueeTopic from '@/components/blocks/miewtheme/BlockMarqueeTopic';
import BlockParallax from '@/components/blocks/miewtheme/BlockParallax/BlockParallax';
import BlockTimerContdown from '@/components/blocks/miewtheme/BlockTimerContdown';
import BlockPoliticalParties from '@/components/blocks/miewtheme/BlockPoliticalParties/BlockPoliticalParties';
import AudioPlayer from '@/components/blocks/core/BlockAudio/BlockAudio';
import BlockMemberStates from '@/components/blocks/miewtheme/BlockMemberStates/BlockMemberStates';
import BlockEuropeNews from '@/components/blocks/miewtheme/BlockEuropeNews';
import BlockTimeLineContent from '@/components/blocks/miewtheme/BlockTimeLineContent';
import BlockNoticeCard from '@/components/blocks/miewtheme/BlockNoticeCard';
import BlockQuizz from '@/components/blocks/miewtheme/BlockQuizz';

export default function displayBlock(block: BlocksProps, index: number) {
    const { attrs, blockName, innerBlocks } = block;

    // prettier-ignore
    switch (blockName) {
    case 'miewtheme/search-page': {
      return <BlockSearchPage attrs={attrs} key={index} />
    }
    case 'core/block': {
      return <BlockReusable innerBlocks={innerBlocks} key={index} />
    }

    case 'core/image': {
      attrs.fill = false
      attrs.className = (attrs?.className || '') + ' wp-image d-inline-block w-100'
      // attrs.style={
      //   maxWidth: `${attrs?.width}px`
      // }
      return (
        <BlockImage
          key={index}
          attrs={attrs}
        />
      )
    }

    case 'core/heading': {
      return <BlockHeading attrs={attrs} key={index} />
    }

    case 'core/paragraph': {
      return <BlockParagraph attrs={attrs} key={index} />
    }

    case 'miewtheme/button': {
      return <BlockButton attrs={attrs} key={index} />
    }

    case 'core/list': {
      return <BlockList attrs={attrs} innerBlocks={innerBlocks} key={index} />
    }

    case 'core/quote': {
      return <BlockQuote attrs={attrs} key={index} />
    }

    case 'core/video': {
      return <BlockVideo attrs={attrs} key={index} />
    }
    case 'core/embed': {
      attrs.embed = attrs?.url;
      return <BlockVideoEmbed attrs={attrs} key={index} />
    }

    case 'core/columns': {
      return (
        <BlockColumns
          attrs={attrs}
          innerBlocks={innerBlocks}
          key={index}
        />
      )
    }

    case 'core/group': {
      return <BlockGroup attrs={attrs} innerBlocks={innerBlocks} key={index} />
    }

    case 'core/cover': {
      return <BlockCover attrs={attrs} innerBlocks={innerBlocks} key={index} />
    }

    case 'miewtheme/accordion': {
      return <BlockAccordion attrs={attrs} innerBlocks={innerBlocks} key={index} />
    }

    case 'miewtheme/spacer': {
      return <BlockSpacer attrs={attrs} key={index} />
    }

    case 'miewtheme/separator': {
      return <BlockSeparator attrs={attrs} key={index} />
    }

    case 'miewtheme/modal': {
      return <BlockModal attrs={attrs} innerBlocks={innerBlocks} key={index} />
    }

    case 'miewtheme/iconbox': {
      return <BlockIconBox attrs={attrs} key={index} />
    }

    case 'miewtheme/icontitle': {
      return <BlockIconTitle attrs={attrs} innerBlocks={innerBlocks} key={index} />
    }
    case 'miewtheme/carousel': {
      return <BlockCarousel attrs={attrs} innerBlocks={innerBlocks} key={index} />
    }
    case 'miewtheme/marquee': {
      return <BlockMarquee attrs={attrs} key={index} />
    }
    case 'miewtheme/marquee-topic': {
      return <BlockMarqueeTopic attrs={attrs} key={index} />
    }
    case 'miewtheme/parallax-card': {
      return <BlockParallax attrs={attrs} key={index} />
    }
    case 'miewtheme/timer-countdown': {
      return <BlockTimerContdown attrs={attrs} key={index} />
    }
    case 'miewtheme/archive-grid': {
      return <BlockArchiveGrid attrs={attrs} key={index} />
    }
    case 'miewtheme/taxonomy-grid': {
      return <BlockTaxonomyGrid attrs={attrs} key={index} />
    }

    case 'miewtheme/logos-grid': {
      return <BlockLogosGrid attrs={attrs} key={index} />
    }
    case 'miewtheme/political-parties': {
      return <BlockPoliticalParties attrs={attrs} key={index} />
    }
    case 'miewtheme/member-states': {
      return <BlockMemberStates attrs={attrs} key={index} />
    }
    case 'miewtheme/eventos-chave': {
      return <BlockTimeLineContent attrs={attrs} key={index} />
    }
    case 'miewtheme/europe-news-grid': {
      return <BlockEuropeNews attrs={attrs} key={index} />
    }
    case 'gravityforms/form': {
      return <BlockGravityForm attrs={attrs} key={index} />
    }
    case 'core/audio': {
      return <AudioPlayer attrs={attrs} key={index} />
    }
    case 'miewtheme/notice-card': {
      return <BlockNoticeCard attrs={attrs} key={index} />
    }
    case 'miewtheme/quizz': {
      return <BlockQuizz attrs={attrs} key={index} />
    }

    // case 'core/media-text': {
    //   return <BlockMediaText attrs={attrs} innerBlocks={innerBlocks} key={index} valueKey={`media-text-${index}`} />
    // }

    default: {
      if (process.env.NODE_ENV === 'development') {

        return <pre key={index}>{JSON.stringify(block, null, 2)}</pre>
      } else {
        return <></>
      }
    }
  }
}
